import api from "./configuration";
import apiUrl from "./url";
import moment from "moment";
import {RosterAPI} from "./roster";
import {getInternalClubId} from "@/utils/constants";

const USE_AUTH_INTERCEPTOR = true;

export const MedicalAPI = {
	recordsList: async (params) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/MedicalRecords",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params,
		});

		return response.data;
	},
	recordCreate: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/MedicalRecords",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	recordUpdate: async (id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/MedicalRecords/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	recordGetById: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/MedicalRecords/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	recordDelete: async (id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/MedicalRecords/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	injuryGetById: async (recordId, id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/MedicalRecords/" + recordId + "/injuries/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});
		return response.data;
	},
	injuryCreate: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/MedicalRecords/injuries",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	injuryUpdate: async (recordId, id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/MedicalRecords/" + recordId + "/injuries/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	injuryDelete: async (recordId, id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/MedicalRecords/" + recordId + "/injuries/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
};

export const isInjuryActiveAt = (injury, date) => {
	const eventDate = moment(date);
	return (
		!injury.recordType &&
		eventDate.isValid() &&
		moment(injury.startDate).isSameOrBefore(eventDate, "day") &&
		(!injury.sportsDischargeDate ||
			moment(injury.sportsDischargeDate).isAfter(eventDate, "day"))
	);
};

// Giorni fuori: dall'inizio alla dimissione (sportiva per gli infortuni, medica per le malattie) o a oggi
export const injuryDaysOut = (item) => {
	if (!item?.startDate) return null;
	const endDate = item.recordType
		? item.medicalDischargeDate
		: item.sportsDischargeDate;
	const end = endDate ? moment(endDate) : moment();
	return Math.max(0, end.diff(moment(item.startDate), "days"));
};

export const loadMedicalRosterMemberships = async (seasonId) => {
	if (!seasonId) return new Map();
	const clubId = getInternalClubId();
	if (!clubId) return new Map();
	const rosters = (
		(await RosterAPI.list({seasonId, clubId, prospect: false})) || []
	).filter(
		(r) => r.seasonId === seasonId && r.clubId === clubId && !r.prospect,
	);
	const memberships = new Map();
	for (const roster of rosters) {
		const players = roster.players || [];
		for (const member of players) {
			const id = member.playerId || member.player?.id;
			const list = memberships.get(id) || [];
			if (!list.some((r) => r.id === roster.id))
				list.push({id: roster.id, name: roster.name});
			memberships.set(id, list);
		}
	}
	return memberships;
};

export const loadMedicalRosterRecords = async (seasonId) => {
	if (!seasonId) return [];
	const memberships = await loadMedicalRosterMemberships(seasonId);
	const records = await MedicalAPI.recordsList({seasonId});
	return (records || [])
		.filter((record) => memberships.has(record.playerId))
		.map((record) => ({
			...record,
			currentRosters: memberships.get(record.playerId),
		}));
};
